import { useEffect, useState } from "react";
import { getPincodeApi } from "../config/api";
import { useDebounce } from "./useDebounce";

const usePincode = (pincode: string) => {
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const debouncedPincode = useDebounce(pincode, 500);

  useEffect(() => {
    if (debouncedPincode.length === 6) {
      setIsLoading(true);
      fetchPincodeData(debouncedPincode).then((data) => {
        setCity(data?.city);
        setState(data?.state);
      });
    } else {
      setCity('');
      setState('');
    }
    setIsLoading(false);
  }, [debouncedPincode, debouncedPincode.length]);

  return { city, state, isLoading };
};

const fetchPincodeData = async (pincode: string) => {
  try {
    let { data } = await getPincodeApi(pincode);

    const city = data?.data?.city ? data?.data?.city : "";
    const state = data?.data?.state ? data?.data?.state : "";

    return { city, state };
  } catch (error) {
    console.log(error);

    let city = "";
    let state = "";

    return { city, state };
  }
};

export default usePincode;
